import { render, staticRenderFns } from "./StatWidget.vue?vue&type=template&id=3906e79b&"
import script from "./StatWidget.vue?vue&type=script&lang=js&"
export * from "./StatWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports